<template>
  <div
    class="cover-image"
    :style="{'background-image': 'url('+src+')'}"
    :class="type"
  >
    <div class="row content">
      <div class="title">
        <h1
          class="mons-title"
          v-if="type === 'landing'"
        >{{ $t('title.landing') }}</h1>
        <p
          v-if="type === 'landing'"
          class="label"
        >{{ $t('label.theme') }}</p>
        <h1>{{ title }}</h1>
      </div>

      <div
        class="editor col-12"
        v-if="type === 'landing'"
      >
        <p class="label">{{ $t(genderLabel) }}</p>
        <h2>{{ subtitle }}</h2>
      </div>
      <h2 v-if="subtitle && type !== 'landing'">{{ subtitle }}</h2>
    </div>

    <div class="overlay"></div>
  </div>
</template>

<script>
export default {
  name: 'CoverImage',
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    editorGender: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false,
      default: 'medium',
      validator: function (value) {
        const styles = ['large', 'medium', 'small', 'landing']
        return styles.indexOf(value) > -1
      }
    }
  },
  data () {
    return {
      genderLabel: ''
    }
  },
  mounted () {
    this.updateGenderLabel()
  },
  watch: {
    editorGender: function () {
      this.updateGenderLabel()
    }
  },
  methods: {
    updateGenderLabel () {
      switch (this.editorGender) {
        case 'm':
          this.genderLabel = 'label.editor'
          break
        case 'f':
          this.genderLabel = 'label.editor_female'
          break
        case 'o':
          this.genderLabel = 'label.editors'
          break
        case 'of':
          this.genderLabel = 'label.editors_female'
          break
        default:
          this.genderLabel = 'label.editor'
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/_vars.scss";

.cover-image {
  overflow: hidden;
  position: relative;
  width: 100%;
  padding-top: 2rem;
  background: $light-gray;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  margin-bottom: 2rem;

  &.small {
    height: 15rem;
  }

  &.medium {
    height: 20rem;
  }

  &.landing {
    height: 26rem;
  }

  &.large {
    height: 30rem;
  }

  &.no-margin {
    margin-bottom: 0;
  }

  @media (max-width: $device-sm) {
    padding-top: 6rem;
  }

  .overlay {
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
  }

  .content {
    z-index: 10;
    position: relative;
    text-align: center;
    height: 100%;
    margin: auto;

    .mons-title {
      color: $secondary-color;
      font-weight: $semibold;
      margin-bottom: 2rem;
      font-size: 1rem;
      text-transform: uppercase;
    }

    .title {
      width: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-60%);
      padding: 1rem;

      p {
        margin-bottom: 0.5rem;
      }
    }

    .label {
      font-size: 0.75rem;
      text-transform: uppercase;
      letter-spacing: 3px;
      text-align: center;
    }

    .editor {
      position: absolute;
      bottom: 1.5rem;
      left: 0;
      margin-top: 1.5rem;
      p {
        margin: 0;
      }
    }

    h1,
    h2,
    p {
      display: block;
      width: 100%;
      text-align: center;
      color: white;
    }

    h1 {
      font-size: 2rem;
      font-weight: $semibold;
      margin-bottom: 0.5rem;
      text-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
    }

    h2 {
      font-weight: $semibold;
      text-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
      font-size: 1.4rem;
    }
  }
}

@media (max-width: $device-sm) {
  .cover-image {
    .content {
      h1 {
        font-size: 1.8rem;
      }
      h2 {
        font-size: 1.2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// CoverImage.vue?140fe279